import * as React from 'react';
import { useQuery } from '@apollo/react-hooks';

import COURSE_PRICES_QUERY from '../graphql/coursePrices.graphql';

type GraphqlData = {
  course: {
    prices: {
      currencyCode: string;
      currencySymbol: string;
      price: number;
      realPrice: number;
      discount: number;
    };
  };
};
type GraphqlVariables = {
  id: string;
};

type State = {
  loading: boolean;
  error?: boolean;
  prices?: GraphqlData['course']['prices'];
};

type PricesContextProviderProps = {
  id: string;
};

const PricesContext = React.createContext<State | undefined>(undefined);

export const PricesContextProvider: React.FC<PricesContextProviderProps> = ({
  children,
  id,
}) => {
  const { loading, data, error } = useQuery<GraphqlData, GraphqlVariables>(
    COURSE_PRICES_QUERY,
    {
      variables: {
        id,
      },
    },
  );

  /**
   * Disable temporally.
   * We'll enable this once the Split (v2/v3) and restructuration of files and folders are finished
   */
  // const childrenMemoized = React.useMemo(() => children, []);

  return (
    <PricesContext.Provider
      value={{
        loading,
        error: Boolean(error),
        prices: data?.course.prices,
      }}
    >
      {children}
    </PricesContext.Provider>
  );
};

export const usePricesContext = () => {
  const context = React.useContext(PricesContext);

  if (context === undefined) {
    throw new Error(
      'usePricesContext must be used within a PricesContextProvider.',
    );
  }

  return context;
};

export default PricesContext;
